// const PouchDB = require('pouchdb')
// PouchDB.plugin(require('pouchdb-upsert'))
// const db = new PouchDB('session-pouchdb')
//
// export default db

export default {
  get: function(key) {
    return JSON.parse(window.localStorage.getItem(key))
  },
  set: function(key, value) {
    return window.localStorage.setItem(key, JSON.stringify(value))
  }
}



// WEBPACK FOOTER //
// ./src/db.js